import { useGetOptimizelyReactivate } from './useGetOptimizelyReactivate';

export const Optimizely = ({ children }: any) => {
  useGetOptimizelyReactivate();
  return children;
};
